// src/features/tasks/tasksSlice.ts
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isModalOpen: false,
  selectedTaskId: null,
};

const tasksSlice = createSlice({
  name: "tasks",
  initialState,
  reducers: {
    openModal: (state) => {
      state.isModalOpen = true;
    },
    closeModal: (state) => {
      state.isModalOpen = false;
      state.selectedTaskId = null;
    },
    selectTask: (state, action) => {
      state.selectedTaskId = action.payload;
    },
  },
});

export const { openModal, closeModal, selectTask } = tasksSlice.actions;
export default tasksSlice.reducer;
